import React, { useState } from "react";
import { Map } from "immutable";
import T from "prop-types";
import { ToggleSwitch } from "MODULES/shared/containers";
import {
  Modal,
  Header,
  Close,
  Body,
  Footer
} from "MODULES/shared/components/Modal";
import { DropDownItem, Icon } from "MODULES/shared/components";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import DownloadUrl from "MODULES/SalesOrders/components/Detail/Actions/DownloadPackingSlip/DownloadUrl";
import withSalesOrder from "../../../../decorators/withSalesOrder";

function DownloadPackingSlip({ salesOrder }) {
  const [includeSoldTo, setIncludeSoldTo] = useState(true);

  const labelClasses = classNames("btn btn-default", {
    active: includeSoldTo
  });

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="file-text-o" fixed />
          &nbsp;Download Packing Slip
          <Modal open={visible} close={close} dialogClass="modal-sm">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Download Packing Slip</h4>
            </Header>
            <Body>
              <h3 style={{ textAlign: "center" }}>
                Include Sold To Company On Packing Slip?
              </h3>
              <div style={{ width: "40%", margin: "0 auto" }}>
                <div className="form-group">
                  <div
                    className="btn-group btn-group-justified"
                    data-toggle="buttons"
                  >
                    <label htmlFor="sold_to" className={labelClasses}>
                      <input
                        type="checkbox"
                        id="sold_to"
                        checked={includeSoldTo}
                        onChange={() => {
                          setIncludeSoldTo(!includeSoldTo);
                        }}
                      />
                      <i className={`fa fa-lg fa-check-circle`} />
                      &nbsp;&nbsp;Include Sold To
                    </label>
                  </div>
                </div>
              </div>
            </Body>
            <Footer>
              <DownloadUrl
                salesOrder={salesOrder}
                includeSoldTo={includeSoldTo}
                close={close}
              />
              <Button onClick={close}>Cancel</Button>
            </Footer>
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

export default withSalesOrder(DownloadPackingSlip);

DownloadPackingSlip.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadPackingSlip/DownloadPackingSlip.jsx